export const UpdateCard = ({ update, compact = false }) => (
  <a
    href={update.href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`update-card-${update.id}`}
    className="group block border-2 border-primary/20 bg-background hover:border-accent transition-colors"
  >
    <div className={`relative overflow-hidden bg-foreground ${compact ? "aspect-[4/3]" : "aspect-square"}`}>
      <img
        src={update.image}
        alt={update.imageAlt}
        data-testid={`update-image-${update.id}`}
        className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
        loading="lazy"
      />
    </div>
    <div className="p-5 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 font-mono text-xs uppercase tracking-[0.12em] text-primary/55">
        <span data-testid={`update-category-${update.id}`}>{update.category}</span>
        <span data-testid={`update-date-${update.id}`}>{update.date}</span>
      </div>
      <h3 data-testid={`update-title-${update.id}`} className="mt-3 font-display text-xl md:text-2xl font-bold leading-tight text-primary">
        {update.title}
      </h3>
      {!compact && <p data-testid={`update-summary-${update.id}`} className="mt-3 text-sm md:text-base text-foreground/70 leading-relaxed">{update.summary}</p>}
      <span className="mt-5 inline-flex font-mono text-xs uppercase tracking-[0.12em] text-accent">View on Instagram →</span>
    </div>
  </a>
);